import script from "./OcrTaxLineRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./OcrTaxLineRow.vue?vue&type=script&setup=true&lang=ts"

import "./OcrTaxLineRow.vue?vue&type=style&index=0&id=0a37a058&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a37a058"]])

export default __exports__